import React from 'react';

// Matches the `track` SegmentedControl beside it in the controls panel — same hairline border,
// radius and 13px label — so the control groups read as one row.
export const CONTROL_SELECT_CLASS_NAME =
    'tw-block tw-w-full tw-h-[31px] tw-py-0 tw-px-3 tw-bg-white tw-border tw-border-[#e3e6ea] tw-rounded-lg tw-text-[13px] tw-text-charcoal';

/**
 * The reporting window: All dates, the next 6/12/24 months, or one calendar year for every year
 * from the first to the last roadmap milestone.
 */
const RoadmapPeriodSelect = ({ value, years, onChange }) => {
    const yearOptions = [...years];
    const selectedYear = value.startsWith('year_') ? Number(value.slice(5)) : null;

    // A saved year the plan no longer reaches still shows as selected.
    if (selectedYear && !yearOptions.includes(selectedYear)) {
        yearOptions.push(selectedYear);
        yearOptions.sort((a, b) => a - b);
    }

    return (
        <select
            id="roadmap-period"
            name="roadmap-period"
            className={CONTROL_SELECT_CLASS_NAME}
            value={value}
            onChange={(event) => onChange(event.target.value)}
        >
            <option value="all">{$t('All dates')}</option>
            <option value="next_6">{$t('Next 6 months')}</option>
            <option value="next_12">{$t('Next 12 months')}</option>
            <option value="next_24">{$t('Next 24 months')}</option>
            {yearOptions.map((year) => (
                <option key={year} value={`year_${year}`}>
                    {year}
                </option>
            ))}
        </select>
    );
};

export default RoadmapPeriodSelect;
